<template>
  <div>
    <b-row>
      <b-col
        xl="3"
        lg="4"
        md="5"
      >
        <FormCardProfileVue :loading="loading" />
      </b-col>
      <b-col
        xl="9"
        lg="8"
        md="7"
      >
        <b-tabs lazy>
          <b-tab
            v-if="verificarPermissao('ROLE_AGREGADO_CONSULTAR')"
            :active="!$route.query.tab || $route.query.tab === 'pessoal'"
          >
            <template #title>
              <feather-icon icon="UserIcon" />
              <span>Pessoal</span>
            </template>
            <FormPersonalInfoVue :loading="loading" />
          </b-tab>

          <b-tab
            v-if="verificarPermissao('ROLE_FINAN_CONSULTAR')"
            :active="$route.query.tab === 'financeiro'"
          >
            <template #title>
              <feather-icon icon="DollarSignIcon" />
              <span>Financeiro</span>
            </template>
            <FormFinacialVue />
          </b-tab>

          <b-tab v-if="verificarPermissao('ROLE_ATEND_CONSULTAR')">
            <template #title>
              <feather-icon icon="PhoneIcon" />
              <span>Atendimento</span>
            </template>
            <FormAttendanceVue />
          </b-tab>

          <b-tab v-if="verificarPermissao('ROLE_ADMIM_CONSULTAR')">
            <template #title>
              <feather-icon icon="LinkIcon" />
              <span>Vinculos</span>
            </template>
            <FormLinkVue :loading="loading" />
          </b-tab>

          <b-tab v-if="verificarPermissao('ROLE_DOCUMENTO_CONSULTAR')">
            <template #title>
              <feather-icon icon="FileTextIcon" />
              <span>Documentos</span>
            </template>
            <FormDocumentationsVue />
          </b-tab>

          <b-tab disabled>
            <template #title>
              <feather-icon icon="CalendarIcon" />
              <span>Eventos</span>
            </template>
            <FormEventsVue />
          </b-tab>

          <b-tab v-if="verificarPermissao('ROLE_PROTOCOLO_CONSULTAR')">
            <template #title>
              <feather-icon icon="FileIcon" />
              <span>Protocolos</span>
            </template>
            <FormProtocolVue />
          </b-tab>

          <b-tab v-if="verificarPermissao('ROLE_RELATORIO_CONSULTAR')">
            <template #title>
              <feather-icon icon="PrinterIcon" />
              <span>Relatorios</span>
            </template>
            <FormReportsVue />
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import {
  BRow, BCol, BTabs, BTab,
} from 'bootstrap-vue'
import mixinsGlobal from '@/mixins'

const FormPersonalInfoVue = () => import('../aggregates/forms/personal/FormAggregates.vue')
const FormFinacialVue = () => import('../aggregates/forms/finance/FormFinancial.vue')
const FormAttendanceVue = () => import('../aggregates/forms/attendance/FormAttendance.vue')
const FormDocumentationsVue = () => import('../aggregates/forms/documentations/FormDocumentations.vue')
const FormEventsVue = () => import('../aggregates/forms/events/FormEvents.vue')
const FormReportsVue = () => import('../aggregates/forms/report/GridReport.vue')
const FormLinkVue = () => import('../aggregates/forms/link/FormLink.vue')
const FormProtocolVue = () => import('../aggregates/forms/protocol/FormProtocol.vue')
const FormCardProfileVue = () => import('../aggregates/forms/personal/FormCardProfileAggregate.vue')

export default {
  components: {
    BRow,
    BCol,
    BTabs,
    BTab,
    FormPersonalInfoVue,
    FormFinacialVue,
    FormAttendanceVue,
    FormDocumentationsVue,
    FormEventsVue,
    FormReportsVue,
    FormCardProfileVue,
    FormLinkVue,
    FormProtocolVue,
  },
  mixins: [mixinsGlobal],
  data() {
    return {
      loading: true,
    }
  },
  async mounted() {
    this.loading = true
    const allPrimis = []
    let aggregatePromise = null

    try {
      // 1. Inicia todas as chamadas de combos em paralelo
      if (this.verificarPermissao('ROLE_GENERO_CONSULTAR')) {
        allPrimis.push(this.$store.dispatch('aggregatesAdministrativeModule/loadComboGenero'))
      }
      if (this.verificarPermissao('ROLE_ESTADO_CIVIL_CONSULTAR')) {
        allPrimis.push(this.$store.dispatch('aggregatesAdministrativeModule/loadComboEstadoCivil'))
      }
      if (this.verificarPermissao('ROLE_PROFISSAO_CONSULTAR')) {
        allPrimis.push(this.$store.dispatch('aggregatesAdministrativeModule/loadComboProfissoes'))
      }
      if (this.verificarPermissao('ROLE_NATURALIDADE_CONSULTAR')) {
        allPrimis.push(this.$store.dispatch('aggregatesAdministrativeModule/loadComboNaturalidades'))
      }
      if (this.verificarPermissao('ROLE_NACIONALIDADE_CONSULTAR')) {
        allPrimis.push(this.$store.dispatch('aggregatesAdministrativeModule/loadComboNacionalidades'))
      }
      if (this.verificarPermissao('ROLE_TIPO_REGISTRO_CONSULTAR')) {
        allPrimis.push(this.$store.dispatch('aggregatesAdministrativeModule/loadComboTypesRegister'))
      }
      if (this.verificarPermissao('ROLE_UF_CONSULTAR')) {
        allPrimis.push(this.$store.dispatch('aggregatesAdministrativeModule/loadComboUfs'))
      }
      if (this.verificarPermissao('ROLE_PREVIDENCIA_SOCIAL_CONSULTAR')) {
        allPrimis.push(this.$store.dispatch('aggregatesAdministrativeModule/loadComboPrevidenciaSocial'))
      }
      if (this.verificarPermissao('ROLE_TIPO_ENDERECO_CONSULTAR')) {
        allPrimis.push(this.$store.dispatch('aggregatesAdministrativeModule/loadComboTipoEndereco'))
      }
      if (this.verificarPermissao('ROLE_SITUACAO_REGISTRO_CONSULTAR')) {
        allPrimis.push(this.$store.dispatch('aggregatesAdministrativeModule/loadComboSituacaoRegistro'))
      }
      if (this.verificarPermissao('ROLE_FAIXA_CONTRIBUICAO_CONSULTAR')) {
        allPrimis.push(this.$store.dispatch('combosModule/loadComboFaixaContribuicao'))
      }

      // 2. Inicia a busca dos dados do agregado em paralelo
      if (this.verificarPermissao('ROLE_AGREGADO_CONSULTAR')) {
        aggregatePromise = this.$store.dispatch('aggregatesAdministrativeModule/getAggregateID', this.$route.params.id)
      }

      // 3. Aguarda o término de todas as requisições paralelas
      await Promise.all([...allPrimis, aggregatePromise].filter(p => p !== null))

      // 4. Se buscou o agregado, processa os dados e prepara a edição
      if (aggregatePromise) {
        const response = await aggregatePromise
        const objectAggregate = response.data
        if (objectAggregate.foto) {
          objectAggregate.foto = `data:image/jpeg;base64,${objectAggregate.foto}`
        }
        await this.$store.dispatch(
          'aggregatesAdministrativeModule/prepareToEditFullAggregate',
          objectAggregate,
        )
        this.$store.dispatch(
          'aggregatesAdministrativeModule/setAssociante',
          objectAggregate.associado,
        )
      }

      this.loading = false
    } catch (error) {
      console.error(error)
      this.MensagemError('Error', 'Erro ao carregar dados da tela!')
      this.loading = false
      this.$router.go(-1)
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-wizard.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>
